// @ts-ignore
import * as crypto from 'crypto';
import transform from 'lodash/transform';
import isObject from 'lodash/isObject';
import trimEnd from 'lodash/trimEnd';
import { DateTime } from 'luxon';
import Vue from 'vue';

export const formatFileSize = (size: number): string =>
{
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const threshold = 1024;
    size = Number(size) * threshold;
    const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
    size = size / Math.pow(threshold, i);

    return `${size.toFixed(2)} ${units[i]}`;
};

export const polishPlurals = (singularNominativ: string, pluralNominativ: string, pluralGenitive: string, value: number): string =>
{
    value = Math.abs(value);

    if (value === 1)
        return singularNominativ;
    else if (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20))
        return pluralNominativ;
    else
        return pluralGenitive;
};

export const deepMap = (data: any, callback: (data: any) => any, policy: (data: any) => boolean = (value: any) => true): any => transform(data, (result: any, value: any, key: string|number): any =>
{
    result[key] = policy(value) && isObject(value) ? deepMap(value, callback) : callback(value);

    return result;
});

export const formatDateTime = (value: DateTime|Date|string, format: string = 'yyyy-MM-dd HH:mm:ss', zone: string = null): string =>
{
    if (value && format)
    {
        zone = zone || DateTime.local().zoneName;

        if (value instanceof Date)
            value = DateTime.fromJSDate(value);
        if (typeof value === 'string')
            value = DateTime.fromISO(value);

        return value.setZone(zone).toFormat(format);
    }

    return '';
};

export const md5 = (contents: string): string =>
{
    return crypto.createHash('md5').update(contents).digest("hex");
};

export const requestToken = (input: string, salt: string): string =>
{
    return md5(input + '#' + salt);
};

export const baseurl = (value: string): string =>
{
    return `${trimEnd(process.env.VUE_APP_PUBLIC_URL, '/')}/${value}`;
};

const ISO_8601 = /(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2}(\.\d{3})?)Z/;

export const convertDates = (result: any): any =>
{
    if (result && isObject(result))
    {
        result = deepMap(result, function(value)
        {
            if (typeof value === 'string' && (value.length == 20 || value.length == 24) && ISO_8601.test(value))
            {
                return DateTime.fromISO(value).setZone('UTC');
            }

            return value;
        });
    }

    return result;
};

export const datesToString = (result: any): any =>
{
    if (result && isObject(result))
    {
        result = deepMap(result,
            (value) =>
            {
                if (DateTime.isDateTime(value))
                {
                    return value.toString();
                }

                return value;
            },
            (value) =>
            {
                return !DateTime.isDateTime(value);
            }
        );
    }

    return result;
};

Vue.mixin({
    methods: {
        formatFileSize: formatFileSize,
        polishPlurals: polishPlurals,
        formatDateTime: formatDateTime,
        baseurl: baseurl
    }
});
